export const FirebaseConfig = {
	"projectId": "social-taxi-app",
	"appId": "1:260205072658:web:e44d7a4daa8f89d1a0a3cb",
	"databaseURL": "https://social-taxi-app-default-rtdb.firebaseio.com",
	"storageBucket": "social-taxi-app.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyBMbl5JubU1eh2IDCpqa6EvV9MCrQvtSyM",
	"authDomain": "social-taxi-app.firebaseapp.com",
	"messagingSenderId": "260205072658"
};